import { render, staticRenderFns } from "./MyQuestions.vue?vue&type=template&id=c53748a8&scoped=true"
import script from "./MyQuestions.vue?vue&type=script&lang=js"
export * from "./MyQuestions.vue?vue&type=script&lang=js"
import style0 from "./MyQuestions.vue?vue&type=style&index=0&id=c53748a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53748a8",
  null
  
)

export default component.exports